import { render } from "./gallery-preview.vue?vue&type=template&id=74c49b9c&scoped=true"
import script from "./gallery-preview.vue?vue&type=script&lang=js"
export * from "./gallery-preview.vue?vue&type=script&lang=js"

import "./gallery-preview.vue?vue&type=style&index=0&id=74c49b9c&scoped=true&lang=css"
import "./gallery-preview.vue?vue&type=style&index=1&id=74c49b9c&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c49b9c"]])

export default __exports__